<template>
  <div id="main_header_v2_container">
    <div id="main_header_v2">
      <router-link to="/" :class="{ 'hamburger_logo': hamburger_visible }">
        <img src="@/assets/imgs/new_logo.svg" id="logo" />
      </router-link>

      <div v-if="mq_lt_lg">
        <img
          id="main_hamburger_open_icon"
          v-show="!hamburger_visible"
          src="@/assets/imgs/white_ham_menu.svg"
          @click="hamburger_visible = true" />

        <img
          id="main_hamburger_close_icon"
          v-show="hamburger_visible"
          src="@/assets/imgs/x-white.svg"
          @click="hamburger_visible = false" />

        <div id="main_hamburger" v-show="hamburger_visible">
          <MainNavV2 hamburger
             @nav="hamburger_visible = false" />
        </div>
      </div>

      <MainNavV2 v-if="mq_gte_lg"/>
    </div>
  </div>
</template>
    
<script>
import MainNavV2 from './MainNavV2'

export default {
  name: 'MainHeaderV2',

  components : {
    MainNavV2
  },

  data : function(){
    return {hamburger_visible : false};
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/custom.scss";

#main_header_v2_container{
  padding-top: 16px;
}

#main_header_v2{
  width: 70%;
  margin: auto;

  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  border: 1px solid $eerie-black;
  border-radius: 15px;
  background-image: linear-gradient($grey-7-alpha62, $black-alpha62);
  backdrop-filter: blur(2px);
}

#main_layout_v2.lg #main_header_v2{
  width: 80%;
}

#main_layout_v2.xs #main_header_v2{
  width: 90%;
}

#logo{
  height: 75px;
  width: 107px;
  margin-left: 35px;
}

#main_hamburger{
  background-image: linear-gradient($grey-5-alpha62, $black-alpha62);
  backdrop-filter: blur(2px);

  position: fixed;
  top: 75px;
  right: 0;

  border-radius: 15px;

  display: flex;
  flex-direction: column;

  #nav {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

#main_hamburger_open_icon{
  cursor: pointer;
  margin-right: 15px;
}

#main_hamburger_close_icon{
  cursor: pointer;
  width: 25px;
  margin-right: 15px;
}

#hide_hamburger{
  cursor: pointer;
  position: absolute;
  right: 32px;
  top: 28px;
}
</style>
